/**
 * HTTP layer for Vantage sensor reports. Pulls a unit's sensor-data series from
 * the Vantage reporting service through its own API client.
 *
 * Contains:
 * - fetchSensorData: a unit's Vantage sensor-data series
 */
import { vantageApiClient } from '@sophocles/http-common';

const VANTAGE_REPORTS_BASE = '/unit/reports/';

// /vantage/api/unit/reports/1000/sensor-data/
export const fetchSensorData = (unitId, queryParams) =>
  vantageApiClient.get(`${VANTAGE_REPORTS_BASE}${unitId}/sensor-data/`, { params: queryParams }).then(res => res.data);
